import { resolveCsChatWorkerUrl } from "../config";
import { type CsChatChannel, parseCsChatChannel } from "../types";

/**
 * `/client/channel` を 1 回 fetch して未読スナップショットを取得する。
 *
 * 旧 `useCsChatChannel` の fetch ロジックを移設したもので、Provider から任意の
 * トリガー（mount / route 遷移 / focus / polling）で再取得できるように、React に
 * 依存しない純粋関数として切り出している。`getToken` は TTL キャッシュ付きの
 * getter を渡すことで、呼び出しごとの JWT 発行 mutation を抑制する。
 */
export const fetchCsChatChannelSnapshot = async ({
  getToken,
  signal,
  workerBaseUrl,
}: {
  getToken: () => Promise<string>;
  signal?: AbortSignal;
  workerBaseUrl: string | undefined;
}): Promise<CsChatChannel> => {
  const token = await getToken();
  const response = await fetch(
    `${resolveCsChatWorkerUrl(workerBaseUrl)}/client/channel`,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
      signal,
    },
  );

  if (!response.ok) {
    throw new Error("cs_chat_channel_fetch_failed");
  }

  const parsed = parseCsChatChannel(await response.json());
  if (!parsed) {
    throw new Error("cs_chat_channel_response_invalid");
  }

  return parsed;
};
